import React from "react";
import FlightDetailsAncillaryItem from "../../../../components/elements/FlightDetailsAncillaryItem/FlightDetailsAncillaryItem.js";
import { HealthInsuranceIcon } from "@bookingcom/bui-assets-react/streamline";
import useInsuranceItemController from "./useInsuranceItem.controller.js";
import { customGoal } from "@flights/et-universal";
const InsuranceItem = (props) => {
    const { description, insurancePriceCopy, showLoadingPrice, title } = useInsuranceItemController(props);
    customGoal("flights_strategy_manager_suppress_insurance_non_eur_zone_pos_switch", 2);
    return (React.createElement(FlightDetailsAncillaryItem, { type: "travelInsurance", icon: HealthInsuranceIcon, showLoadingPrice: showLoadingPrice, title: title, description: description, priceCopy: insurancePriceCopy }));
};
export default InsuranceItem;
